<template>
  <div :class="{
    'row': !full
  }">
    <div :class="{
      [ $ALERT_COL ]: !full
    }">
      <Alert class="alert-attention" icon="IconImportant" :title="name + ' is disabled'">
        <p class="mb-0">
          Once you are satisfied with the customizations, <router-link class="alert-link" :to="{ name: to }">click here to enable {{name}} &rarr;</router-link>
        </p>
      </Alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    full: Boolean,
    name: String,
    to: String
  }
}
</script>
